import moment from "moment";
export function getReportData(data, selectedReportType, reportForEdit) {
  let validationErrorMsgs = [],
    reportData = {},
    schedulesConfirmRequired = false;
  data.params = data.params || {}; 
  if (reportForEdit) {
    reportData = Object.assign({}, reportForEdit, {
      customer: data?.selectedCustomerName,
      customerId: data?.params?.customer,
      reportDescription: "",
    });
    delete reportData["isActive"];
  } else {
    reportData = {
      active: data.isActive,
      internalUse: !!data.internalUse,
      customer: data?.selectedCustomerName,
      customerId: data?.params?.customer,
      reportPipelineDefinitionId: selectedReportType.reporttemplatename,
      triggerType: selectedReportType.triggertype,
      reportDescription: "",
    };
  }

  let missedFields = [],
    triggerCriteria = {};
  if (selectedReportType.parameters && selectedReportType.parameters.length) {
    for (let i = 0; i < selectedReportType.parameters.length; i++) {
      const param = selectedReportType.parameters[i];
      if (param.mandatory && !data.params[param.paramName]) {
        if (
          typeof param.mandatory === "string" ||
          param.mandatory instanceof String
        ) {
          selectedReportType.parameters
            .map((item) => item.paramName)
            .forEach((k) => {
              if (param.mandatory.includes(k)) {
                // eslint-disable-next-line no-eval
                if (
                  eval(param.mandatory.replace(k, 'data.params["' + k + '"]'))
                ) {
                  missedFields.push(param.paramDisplayName);
                }
              }
            });
        } else {
          missedFields.push(param.paramDisplayName);
        }
      }
      if (param.triggerCriteriaFieldName) {
        if (data.params && data.params[param.paramName]) {
          triggerCriteria[param.triggerCriteriaFieldName] =
            data.params[param.paramName];
        } else if (param.paramName === "project") {
          var _projects = data.params && data.params["projects"];
          if (_projects && _projects.length > 0) {
            triggerCriteria["project"] = _projects && JSON.stringify(_projects);
          }
        }
      }
    }
  }

  if (missedFields.length > 0) {
    validationErrorMsgs.push(
      "The following field(s) are missed: " + missedFields.join(", ")
    );
  }

  if (
    !data.emailDeliveryState &&
    !data.sftpDeliveryState &&
    !data.ftpDeliveryState
  ) {
    validationErrorMsgs.push(
      "You have to choose at least one transport way: Email or FTP/SFTP."
    );
  }

  let transportitems =
    (reportForEdit &&
      reportForEdit.reportDefComponentsParams &&
      reportForEdit.reportDefComponentsParams.length > 1 &&
      reportForEdit.reportDefComponentsParams[1] &&
      reportForEdit.reportDefComponentsParams[1].data &&
      reportForEdit.reportDefComponentsParams[1].data.transportitems) ||
    [];

  let smtpItem = transportitems.find((obj) => {
    return obj.type === "Smtp";
  });
  if (data.emailDeliveryState) {
    // "subject" and "to" are required
    if (data["emailSubject"] && data["emailTo"] && data["emailTo"].length) {
      if (smtpItem) {
        smtpItem["subject"] = data["emailSubject"];
        smtpItem["to"] = data["emailTo"].join(";");
        smtpItem["cc"] = data["emailCC"].join(";");
        smtpItem["bcc"] = data["emailBCC"].join(";");
      } else {
        transportitems.push({
          id: "SMTP",
          type: "Smtp",
          subject: data["emailSubject"],
          to: data["emailTo"].join(";"),
          cc: data["emailCC"].join(";"),
          bcc: data["emailBCC"].join(";"),
        });
      }
    } else {
      validationErrorMsgs.push(
        'You have to specify "Subject" and "To" fields for email delivery configuration.'
      );
    }
  } else {
    if (smtpItem) {
      // remove item
      var index = transportitems.indexOf(smtpItem);
      if (index > -1) {
        transportitems.splice(index, 1);
      }
    }
  }

  let sftpItem = transportitems.find((obj) => {
    return obj.type === "Sftp";
  });
  if (data.sftpDeliveryState) {
    if (
      data["ftpHost"] &&
      data["ftpPort"] &&
      data["ftpUserName"] &&
      data["ftpUserPassword"]
      //data["ftpUploadPath"]
    ) {
      if (sftpItem) {
        sftpItem["host"] = data["ftpHost"];
        sftpItem["port"] = data["ftpPort"];
        sftpItem["username"] = data["ftpUserName"];
        sftpItem["password"] = data["ftpUserPassword"];
        sftpItem["path"] = data["ftpUploadPath"];
      } else {
        transportitems.push({
          id: "SFTP",
          type: "Sftp",
          host: data["ftpHost"],
          port: data["ftpPort"],
          username: data["ftpUserName"],
          password: data["ftpUserPassword"],
          path: data["ftpUploadPath"],
        });
      }
    } else {
      validationErrorMsgs.push(
        "The following fields are required for FTP/SFTP delivery configuration:<br />Host, Port, Username, and Password."
      );
    }
  } else {
    if (sftpItem) {
      // remove item
      var index2 = transportitems.indexOf(sftpItem);
      if (index2 > -1) {
        transportitems.splice(index2, 1);
      }
    }
  }

  let ftpItem = transportitems.find((obj) => {
    return obj.type === "Ftp";
  });
  if (data.ftpDeliveryState) {
    if (
      data["ftpHost"] &&
      data["ftpPort"] &&
      data["ftpUserName"] &&
      data["ftpUserPassword"]
      //data["ftpUploadPath"]
    ) {
      if (ftpItem) {
        ftpItem["host"] = data["ftpHost"];
        ftpItem["port"] = data["ftpPort"];
        ftpItem["username"] = data["ftpUserName"];
        ftpItem["password"] = data["ftpUserPassword"];
        ftpItem["path"] = data["ftpUploadPath"];
      } else {
        transportitems.push({
          id: "FTP",
          type: "Ftp",
          host: data["ftpHost"],
          port: data["ftpPort"],
          username: data["ftpUserName"],
          password: data["ftpUserPassword"],
          path: data["ftpUploadPath"],
        });
      }
    } else {
      validationErrorMsgs.push(
        "The following fields are required for FTP/SFTP delivery configuration:<br />Host, Port, Username, and Password."
      );
    }
  } else {
    if (ftpItem) {
      // remove item
      var index3 = transportitems.indexOf(ftpItem);
      if (index3 > -1) {
        transportitems.splice(index3, 1);
      }
    }
  }

  let ftpBackupItem = transportitems.find((obj) => {
    return obj.type === "FtpBackup";
  });
  if (!data.sftpDeliveryState && !data.ftpDeliveryState) {
    if (
      data["ftpHost"] &&
      data["ftpPort"] &&
      data["ftpUserName"] &&
      data["ftpUserPassword"]
      //data["ftpUploadPath"]
    ) {
      if (ftpBackupItem) {
        ftpBackupItem["host"] = data["ftpHost"];
        ftpBackupItem["port"] = data["ftpPort"];
        ftpBackupItem["username"] = data["ftpUserName"];
        ftpBackupItem["password"] = data["ftpUserPassword"];
        ftpBackupItem["path"] = data["ftpUploadPath"];
      } else {
        transportitems.push({
          id: "FTPBackup",
          type: "FtpBackup",
          host: data["ftpHost"],
          port: data["ftpPort"],
          username: data["ftpUserName"],
          password: data["ftpUserPassword"],
          path: data["ftpUploadPath"],
        });
      }
    }
  } else {
    if (ftpBackupItem) {
      // remove item
      var index4 = transportitems.indexOf(ftpBackupItem);
      if (index4 > -1) {
        transportitems.splice(index4, 1);
      }
    }
  }

  let reportDefComponentsParams = [
    {
      data: {
        scriptparams: { inputData: data.params },
        reportName: data.reportName,
      },
    },
    {
      data: {
        transportitems,
      },
    },
  ];

  // add schedules for recurringreport
  if (selectedReportType.triggertype === "recurringreport") {
    // validate schedules field
    if (data.scheduleRepeat && data.scheduleNextLaunch) {
      const timezone = data.params?.timezone;
      if (reportData["schedules"] && reportData["schedules"].length) {
        reportData["schedules"][0] = Object.assign(
          {}, 
          reportData["schedules"][0],
          {
            type: data.scheduleRepeat,
            nextlaunch: moment.utc(data.scheduleNextLaunch).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
            timezone,
          }
        );
      } else {
        reportData["schedules"] = [
          {
            type: data.scheduleRepeat,
            nextlaunch: moment.utc(data.scheduleNextLaunch).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
            timezone,
          },
        ];
      }
      if (moment() > data.scheduleNextLaunch) {
        // show confirmation message
        schedulesConfirmRequired = true;
      }
    } else {
      // invalid schedules data
      validationErrorMsgs.push(
        "You have to specify schedule's type and next launch."
      );
    }
  }

  return {
    validationErrorMsgs,
    schedulesConfirmRequired,
    data: {
      ...reportData,
      reportDefComponentsParams,
      //active: this.state.editReportIsActive,
      triggerCriteria,
    },
  };
}
